import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analyticscreditbureau',
  templateUrl: './analyticscreditbureau.component.html',
  styleUrls: ['./analyticscreditbureau.component.css']
})
export class AnalyticscreditbureauComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
